import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../hooks/use-auth';
import { routes } from '../routes';
import { FullScreenLoader } from './full-screen-loader';

export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <FullScreenLoader />;
  }

  if (!isAuthenticated) {
    localStorage.setItem('redirect_after_login', location.pathname + location.search + location.hash);
    return <Navigate to={routes.login} replace />;
  }

  return <Outlet />;
}
